import axios from "axios";
const jsonConfig = require("../../Config.json");
const getVetJobDescription = async (payload) => {
  try {
    const response = await axios.post(
      `${jsonConfig.apiUrl}getallvetjd`,
      payload,
      {
        headers: {
          "x-functions-key": jsonConfig.key,
        },
      }
    );
    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};
export default getVetJobDescription;